<template>
  <div class="hello" style=" padding: 0 20px;">
    <a href="https://www.u-media.com.tw" style=" display: inline-flex; float: left; padding: 11.5px 0px;"><img src="../assets/logo_new.svg" alt="宇智網通" title="宇智網通"></a>
  </div>
</template>
<style>
.el-menu--popup-bottom-start{
  background: linear-gradient(to top, rgba(25, 137, 154, 0.9), rgba(0, 46, 54, 0.93));
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  background-color: rgba(255, 255, 255, 0);
  color: #ffffff !important;
}
.el-menu--popup-bottom-start .el-link.el-link--default {  
  color: #ffffff !important;
}
</style>

<script>
  //import { setJsonDateDecode } from "@/api/portalAction"
  export default {
    data() {
      return {
        isLogin: window.localStorage.isLogin,
        activeIndex: '/',
        urlArray :{}
      };
    },
    mounted: function () {
      let tmpPathname = location.pathname;
      this.activeIndex = tmpPathname;
      console.log(this.activeIndex);
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
        if(key == ""){
          this.$refs.elMenu.activeIndex = null;
        }else{
          this.activeIndex = key;
        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
